// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { withRouter } from 'react-router';

import SimpleField from "../../forms/SimpleField";
import { SelectField } from "../../forms/SelectField";
import { RadioField } from "../../forms/RadioField";
import BackButton from "../../widgets/BackButton";

import Timesheet from "../../../store/wrappers/Timesheet";
import { TimesheetApi } from "../../../util/api/TimesheetApi";
import { observer } from 'mobx-react';
import queryString from "query-string";
import { Alert } from "../../../store/Alert";

import AgreementInfoWidget from "./AgreementInfo";

class TimesheetForm extends Component {
    static displayName = TimesheetForm.name;

    constructor(props) {
        super(props);

        let timesheet = false;

        let displayMode = "new";
        if (this.props.match.params.id) {
            timesheet = this.props.store.timesheets.getById(this.props.match.params.id);
            displayMode = "edit";
        }

        this.state = {
            isSubmitting: false,
            timesheet: timesheet,
            mode: displayMode,
            inactiveReason: timesheet?.inactiveReason || ""
        };

        this.viewPayPeriodForm = this.viewPayPeriodForm.bind(this);
        this.toggleCertify = this.toggleCertify.bind(this);
        this.inactivateTimesheet = this.inactivateTimesheet.bind(this);
        this.updateInactiveReason = this.updateInactiveReason.bind(this);
    }

    showAlert(message, type = "danger", title = "Alert") {
        this.props.store.addAlert(new Alert(title, message, type));
    }

    setInitialValues() {
        let timesheet = this.state.timesheet;
        if (!timesheet) {
            timesheet = new Timesheet();
        }

        return {
            id: timesheet.id ? timesheet.id : null,
            weekEndDate: timesheet.weekEndDate ? new Date(timesheet.weekEndDate) : null,
            payRate: timesheet.payRate || "0",
            totalHours: timesheet.totalHours || "0",
            totalPay: timesheet.totalPay || "0",
            isSigned: timesheet.isSigned ? timesheet.isSigned.toString() : "false",
            isOriginalOnFile: timesheet.isOriginalOnFile ? timesheet.isOriginalOnFile.toString() : "false",
            isPaid: timesheet.isPaid ? timesheet.isPaid.toString() : "false",
            isCertified: timesheet.isCertified ? timesheet.isCertified.toString() : "false",
            accountId: timesheet.accountId || "0",
            timestampIds: timesheet.timestampIds || []
        };
    }

    async handleSubmission(values, setSubmitting) {
        this.setState({ isSubmitting: true });

        if (values.id == null && this.state.timesheet.id) {
            values.id = this.state.timesheet.id;
        }

        let timesheet = new Timesheet(values, true);
        timesheet = await timesheet.save(this.props.store);

        if (timesheet.errors == null || timesheet.errors.length == 0) {
            this.setState({
                timesheet: timesheet,
                isSubmitting: false,
                mode: "edit"
            });
        }
    }

    validate(values) {
        const errors = {};
        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                {this.form()}
            </div>
        );
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Timesheet</h1>
                </React.Fragment>
            );
        }
        return undefined;
    }

    viewPayPeriodForm(event) {
        event.preventDefault();

        const submission = {
            endDay: this.state.timesheet.weekEndDate,
            accountId: this.state.timesheet.accountId
        };

        this.props.history.push("/submission?" + queryString.stringify(submission));
    }

    updateInactiveReason(event) {
        this.setState({ inactiveReason: event.target.value });
    }

    async toggleCertify() {
        const timesheet = this.state.timesheet;

        if (!timesheet || !timesheet.id) {
            return;
        }

        if (timesheet.isInactive) {
            this.showAlert("Inactive timesheets cannot be certified or uncertified.");
            return;
        }

        this.setState({ isSubmitting: true });

        const originalValue = timesheet.isCertified;
        timesheet.isCertified = !timesheet.isCertified;

        const response = await timesheet.save(this.props.store);

        if (response && response.errors && response.errors.length > 0) {
            timesheet.isCertified = originalValue;
        } else {
            this.setState({
                timesheet: response || timesheet,
                isSubmitting: false,
                mode: "edit"
            });
            return;
        }

        this.setState({ isSubmitting: false });
    }

    async inactivateTimesheet() {
        const timesheet = this.state.timesheet;
        const reason = (this.state.inactiveReason || "").trim();

        if (!timesheet || !timesheet.id) {
            return;
        }

        if (timesheet.isInactive) {
            this.showAlert("This timesheet is already inactive.");
            return;
        }

        if (timesheet.isPaid) {
            this.showAlert("Paid timesheets cannot be inactivated.");

            return;
        }

        if (timesheet.isCertified) {
            this.showAlert("Certified timesheets cannot be inactivated.");
            return;
        }

        if (!reason) {
            this.showAlert("Please enter a reason for inactivation.");
            return;
        }

        if (!window.confirm("Are you sure you want to inactivate this timesheet?")) {
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            await TimesheetApi.inactivate(timesheet.id, reason);

            this.props.store.addAlert(
                new Alert("Success", "Timesheet inactivated successfully.", "success")
            );

            await this.props.store.getFromApi(["timesheets", "accounts", "timestamps"]);

            this.setState({ isSubmitting: false });
            this.props.history.goBack();
        } catch (e) {
            console.log(e);

            const apiErrors = e?.response?.data?.errors;

            if (Array.isArray(apiErrors) && apiErrors.length > 0) {
                apiErrors.forEach(error => this.showAlert(error));
            } else if (typeof e?.response?.data === "string" && e.response.data.trim()) {
                this.showAlert(e.response.data);
            } else if (e?.response?.data?.message) {
                this.showAlert(e.response.data.message);
            } else if (e?.message) {
                this.showAlert(e.message);
            } else {
                this.showAlert("An error occurred while inactivating this timesheet.");
            }

            this.setState({ isSubmitting: false });
        }
    }

    form() {
        let named_accounts = this.props.store.accounts.collection;

        named_accounts = named_accounts.map((account) => {
            account.include(["student", "employer"]);
            account.name = `${account.student.name} - ${account.employer.name}`;
            return account;
        });

        const currentAccountName = named_accounts.filter(account => account.id === this.state.timesheet.accountId);

        if (currentAccountName.length > 0) {
            this.props.store.updateBanner("Update Timesheet", currentAccountName[0].name);
        }

        return (
            (this.state.mode == "new" || this.state.timesheet ? (
                <Formik
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting }) => this.handleSubmission(values, setSubmitting)}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field name="id" className="form-control" type="hidden" />

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <SimpleField name="payRate" label="Pay Rate" type="number" min="0" step="0.01" />
                                    <SelectField items={named_accounts} name="accountId" label="Account" />
                                </div>

                                <div className="col-12 col-md-6 d-flex flex-row flex-wrap">
                                    <div className="form-group w-50">
                                        <p>Is Signed?</p>
                                        <RadioField name="isSigned" label="True" value="true" />
                                        <RadioField name="isSigned" label="False" value="false" />
                                        <ErrorMessage name="isSigned" component="div" />
                                    </div>

                                    <div className="form-group w-50">
                                        <label>Is Paid?</label>
                                        <br></br>
                                        <RadioField name="isPaid" label="True" value="true" />
                                        <RadioField name="isPaid" label="False" value="false" />
                                        <ErrorMessage name="isPaid" component="div" />
                                    </div>

                                    <div className="form-group w-50">
                                        <label>Is Original On File?</label>
                                        <br></br>
                                        <RadioField name="isOriginalOnFile" label="True" value="true" />
                                        <RadioField name="isOriginalOnFile" label="False" value="false" />
                                        <ErrorMessage name="isOriginalOnFile" component="div" />
                                    </div>

                                    <div className="form-group w-50">
                                        <label>Is Certified?</label>
                                        <br></br>
                                        <RadioField name="isCertified" label="True" value="true" />
                                        <RadioField name="isCertified" label="False" value="false" />
                                        <ErrorMessage name="isCertified" component="div" />
                                    </div>
                                </div>
                            </div>

                            {this.state.timesheet.id && !this.state.timesheet.isInactive && (
                                <div className="form-group mt-3">
                                    <label>Reason for inactivation</label>
                                    <textarea
                                        className="form-control"
                                        value={this.state.inactiveReason}
                                        onChange={this.updateInactiveReason}
                                        rows="3"
                                    />
                                </div>
                            )}

                            {this.state.timesheet.id && this.state.timesheet.isInactive && (
                                <div className="alert alert-warning mt-3">
                                    This timesheet is inactive.
                                    {this.state.timesheet.inactiveReason && (
                                        <div><strong>Reason:</strong> {this.state.timesheet.inactiveReason}</div>
                                    )}
                                    {this.state.timesheet.dateInactivated && (
                                        <div><strong>Date:</strong> {new Date(this.state.timesheet.dateInactivated).toLocaleString()}</div>
                                    )}
                                    {this.state.timesheet.inactivatedBy && (
                                        <div><strong>By:</strong> {this.state.timesheet.inactivatedBy}</div>
                                    )}
                                </div>
                            )}

                            <div className="staffFormSubmitButtons">
                                {this.state.mode !== "new" &&
                                    <BackButton className="btn btn-secondary mr-2" innerText="Cancel" />
                                }

                                {this.state.timesheet.id && (
                                    <button
                                        className="btn btn-primary btn-lg mr-2"
                                        type="button"
                                        onClick={this.viewPayPeriodForm}
                                    >
                                        Edit Timestamps
                                    </button>
                                )}

                                {this.state.timesheet.id && !this.state.timesheet.isInactive && (
                                    <button
                                        className={`btn mr-2 ${this.state.timesheet.isCertified ? "btn-secondary" : "btn-light"}`}
                                        type="button"
                                        onClick={this.toggleCertify}
                                        disabled={isSubmitting}
                                    >
                                        {this.state.timesheet.isCertified ? "Uncertify" : "Certify"}
                                    </button>
                                )}

                                {this.state.timesheet.id && !this.state.timesheet.isInactive && (
                                    <button
                                        className="btn btn-danger mr-2"
                                        type="button"
                                        onClick={this.inactivateTimesheet}
                                        disabled={isSubmitting}
                                    >
                                        Inactivate Timesheet
                                    </button>
                                )}

                                <button className="btn btn-primary mr-2" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>

                            {/* {this.state.mode !== "new" &&
                                <AgreementInfoWidget timesheetId={this.state.timesheet.id} />
                            } */}
                            {this.state.mode !== "new" &&
                                !this.state.timesheet?.isInactive &&
                                this.state.timesheet?.id &&
                                (
                                    <AgreementInfoWidget timesheetId={this.state.timesheet.id} />
                                )}
                        </Form>
                    )}
                </Formik>
            ) : (
                <div>
                    <h3>Could not find timesheet</h3>
                </div>
            ))
        );
    }
}

TimesheetForm = withRouter(observer(TimesheetForm));

export { TimesheetForm };
// // Render Prop

// import React, { Component } from 'react';
// import { Formik, Form, Field, ErrorMessage } from 'formik';
// import { Redirect, withRouter } from 'react-router';

// import SimpleField from "../../forms/SimpleField";
// import { SelectField } from "../../forms/SelectField";
// import { RadioField } from "../../forms/RadioField";
// import DatePickerField from '../../forms/DatePickerField';
// import BackButton from "../../widgets/BackButton";

// import Timesheet from "../../../store/wrappers/Timesheet";
// import { TimesheetApi } from "../../../util/api/TimesheetApi";
// import { observer } from 'mobx-react';
// import queryString from "query-string";

// import AgreementInfoWidget from "./AgreementInfo";



// class TimesheetForm extends Component {
//     static displayName = TimesheetForm.name;

//     constructor(props) {
//         super(props);

//         let timesheet = false;

//         //If we are editting a timesheet, we provided the id in the url and should fetch it.
//         let displayMode = "new";
//         if (this.props.match.params.id) {
//             timesheet = this.props.store.timesheets.getById(this.props.match.params.id);
//             displayMode = "edit";
//         }


//         this.state = {
//             isSubmitting: false,
//             timesheet: timesheet,
//             mode: displayMode,
//             inactiveReason: ""
//         };

//         this.viewPayPeriodForm = this.viewPayPeriodForm.bind(this);
//         this.toggleCertify = this.toggleCertify.bind(this);
//         this.deleteTimesheet = this.deleteTimesheet.bind(this)
//     }


//     setInitialValues() {
//         let timesheet = this.state.timesheet;
//         if (!timesheet) {
//             timesheet = new Timesheet()
//         }

//         return {
//             id: timesheet.id ? timesheet.id : null,
//             weekEndDate: timesheet.weekEndDate ? new Date(timesheet.weekEndDate) : null,
//             payRate: timesheet.payRate || "0",
//             totalHours: timesheet.totalHours || "0",
//             totalPay: timesheet.totalPay || "0",
//             isSigned: timesheet.isSigned ? timesheet.isSigned.toString() : "false",
//             isOriginalOnFile: timesheet.isOriginalOnFile ? timesheet.isOriginalOnFile.toString() : "false",
//             isPaid: timesheet.isPaid ? timesheet.isPaid.toString() : "false",
//             isCertified: timesheet.isCertified ? timesheet.isCertified.toString() : "false",
//             accountId: timesheet.accountId || "0",
//             timestampIds: timesheet.timestampIds || []
//         }
//     }


//     async handleSubmission(values, setSubmitting) {
//         this.setState({ isSubmitting: true });

//         if (values.id == null && this.state.timesheet.id) {
//             values.id = this.state.timesheet.id;
//         }

//         let timesheet = new Timesheet(values, true);

//         timesheet = await timesheet.save(this.props.store);

//         //Update the state of this application if need be.
//         if (timesheet.errors == null || timesheet.errors.length == 0) {
//             console.log("updated timesheet state")
//             this.setState({
//                 timesheet: timesheet,
//                 isSubmitting: false,
//                 mode: "edit"
//             });
//         }
//     }

//     validate(values) {
//         const errors = {};

//         return errors;
//     }

//     render() {
//         return (
//             <div>
//                 {this.introText()}
//                 {this.form()}
//             </div>
//         )
//     }

//     introText() {
//         if (this.state.mode == "new") {
//             return (
//                 <React.Fragment>
//                     <h1 className="h3">New Timesheet</h1>
//                 </React.Fragment>
//             )
//         }
//         return (undefined)
//     }

//     viewPayPeriodForm(event) {
//         event.preventDefault();

//         const submission = {
//             endDay: this.state.timesheet.weekEndDate,
//             accountId: this.state.timesheet.accountId
//         }

//         this.props.history.push("/submission?" + queryString.stringify(submission));
//     }

//     async toggleCertify() {
//         const timesheet = this.state.timesheet;

//         if (!timesheet || !timesheet.id) {
//             return;
//         }

//         this.setState({ isSubmitting: true });

//         const originalValue = timesheet.isCertified;
//         timesheet.isCertified = !timesheet.isCertified;

//         const response = await timesheet.save(this.props.store);

//         if (response && response.errors && response.errors.length > 0) {
//             timesheet.isCertified = originalValue;
//         } else {
//             this.setState({
//                 timesheet: response || timesheet,
//                 isSubmitting: false,
//                 mode: "edit"
//             });
//             return;
//         }

//         this.setState({ isSubmitting: false });
//     }

//     async deleteTimesheet() {
//         const timesheet = this.state.timesheet;

//         if (!timesheet || !timesheet.id) {
//             return;
//         }

//         if (!window.confirm("Are you sure you'd like to delete this timesheet?")) {
//             return;
//         }

//         this.setState({ isSubmitting: true });

//         try {
//             await TimesheetApi.delete(timesheet.id);

//             await this.props.store.getFromApi(["timesheets", "accounts", "timestamps"]);

//             this.props.history.goBack();
//         } catch (e) {
//             console.log(e);
//             this.props.store.addAlert("An error occurred while deleting this timesheet.");
//             this.setState({ isSubmitting: false });
//         }
//     }

//     form() {
//         let named_accounts = this.props.store.accounts.collection;

//         named_accounts = named_accounts.map((account) => {
//             let copy = account.include(["student", "employer"]);
//             account.name = `${account.student.name} - ${account.employer.name}`;
//             return account;
//         });

//         const currentAccountName = named_accounts.filter(account => account.id === this.state.timesheet.accountId)

//         this.props.store.updateBanner("Update Timesheet", currentAccountName[0].name);


//         return (
//             (this.state.mode == "new" || this.state.timesheet ? (
//                 <Formik
//                     initialValues={this.setInitialValues()}
//                     validate={values => this.validate(values)}
//                     onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting)}
//                 >
//                     {({ isSubmitting }) => (
//                         <Form>

//                             <Field name="id" className="form-control" type="hidden" />

//                             <div className="row">

//                                 <div className="col-12 col-md-6">
//                                     <SimpleField name="payRate" label="Pay Rate" type="number" min="0" step="0.01" />

//                                     <SelectField items={named_accounts} name="accountId" label="Account" />
//                                 </div>

//                                 <div className="col-12 col-md-6 d-flex flex-row flex-wrap">

//                                     <div className="form-group w-50">
//                                         <p>Is Signed?</p>
//                                         <RadioField name="isSigned" label="True" value="true" />
//                                         <RadioField name="isSigned" label="False" value="false" />
//                                         <ErrorMessage name="isSigned" component="div" />
//                                     </div>

//                                     <div className="form-group w-50">
//                                         <label>Is Paid?</label>
//                                         <br></br>
//                                         <RadioField name="isPaid" label="True" value="true" />
//                                         <RadioField name="isPaid" label="False" value="false" />
//                                         <ErrorMessage name="isPaid" component="div" />
//                                     </div>

//                                     <div className="form-group w-50">
//                                         <label>Is Original On File?</label>
//                                         <br></br>
//                                         <RadioField name="isOriginalOnFile" label="True" value="true" />
//                                         <RadioField name="isOriginalOnFile" label="False" value="false" />
//                                         <ErrorMessage name="isOriginalOnFile" component="div" />
//                                     </div>

//                                     <div className="form-group w-50">
//                                         <label>Is Certified?</label>
//                                         <br></br>
//                                         <RadioField name="isCertified" label="True" value="true" />
//                                         <RadioField name="isCertified" label="False" value="false" />
//                                         <ErrorMessage name="isCertified" component="div" />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* <div className="staffFormSubmitButtons">
//                                 {this.state.mode !== "new" &&
//                                     <BackButton className="btn btn-secondary mr-2" innerText="Cancel" />
//                                 }
//                                 {this.state.timesheet.id && (
//                                     <button className="btn btn-primary btn-lg mr-2" type="button" onClick={this.viewPayPeriodForm}>
//                                         Edit Timestamps
//                                     </button>
//                                 )}
//                                 <button className="btn btn-primary mr-2" type="submit" disabled={isSubmitting}>
//                                     Submit
//                                 </button>
//                             </div> */}
//                             <div className="staffFormSubmitButtons">
//                                 {this.state.mode !== "new" &&
//                                     <BackButton className="btn btn-secondary mr-2" innerText="Cancel" />
//                                 }

//                                 {this.state.timesheet.id && (
//                                     <button
//                                         className="btn btn-primary btn-lg mr-2"
//                                         type="button"
//                                         onClick={this.viewPayPeriodForm}
//                                     >
//                                         Edit Timestamps
//                                     </button>
//                                 )}

//                                 {this.state.timesheet.id && (
//                                     <button
//                                         className={`btn mr-2 ${this.state.timesheet.isCertified ? "btn-secondary" : "btn-light"}`}
//                                         type="button"
//                                         onClick={this.toggleCertify}
//                                         disabled={isSubmitting}
//                                     >
//                                         {this.state.timesheet.isCertified ? "Uncertify" : "Certify"}
//                                     </button>
//                                 )}

//                                 {this.state.timesheet.id && (
//                                     <button
//                                         className="btn btn-danger mr-2"
//                                         type="button"
//                                         onClick={this.deleteTimesheet}
//                                         disabled={isSubmitting}
//                                     >
//                                         Delete Timesheet
//                                     </button>
//                                 )}

//                                 <button className="btn btn-primary mr-2" type="submit" disabled={isSubmitting}>
//                                     Submit
//                                 </button>
//                             </div>
//                             {this.state.mode !== "new" &&
//                                 <AgreementInfoWidget timesheetId={this.state.timesheet.id} />
//                             }
//                         </Form>
//                     )}

//                 </Formik>

//             ) :
//                 (
//                     <div>
//                         <h3>Could not find timesheet</h3>
//                     </div>
//                 )
//             )
//         );
//     }
// }

// TimesheetForm = withRouter(observer(TimesheetForm));

// export { TimesheetForm };